import {
  Client,
  DistributorEmployee,
  DistributorProfile,
} from "creso-core/types";
import { format } from "date-fns";
import { imageAssetUrl } from "@/utils/url";
import { JOINT_CLIENT_HOLDING_PATTERNS } from "creso-core/constants";
import { DistributorProfileSummary } from "../distributor-profile-summary";
import { EmployeePortfolioSummary } from "../employee-portfolio-summary";

interface CoverSectionProps {
  client: Client;
  title: string;
  createdAt: string;
  distributorProfile: DistributorProfile;
  employee?: DistributorEmployee | null;
}

export function CoverSection({
  client,
  title,
  createdAt,
  distributorProfile,
  employee,
}: CoverSectionProps) {
  return (
    <div className="flex h-[calc(100vh-200px)] flex-row">
      <div className="flex flex-col flex-1 h-full pt-15 pb-4 justify-between">
        <div className="flex flex-col gap-1">
          <span className="text-2xl font-semibold">{client?.name}</span>
          <span className="text-sm text-muted-foreground">
            {client.pan} | {client.phone_number}
            {client.holding_pattern &&
            JOINT_CLIENT_HOLDING_PATTERNS.includes(client.holding_pattern)
              ? " | Joint"
              : null}
          </span>
        </div>
        <div className="flex flex-col gap-1">
          <span className="font-semibold text-4xl">{title}</span>
          <span className="text-sm text-muted-foreground">
            Created on {format(createdAt, "dd MMMM yyyy")}
          </span>
        </div>
        {employee ? (
          <EmployeePortfolioSummary
            employee={employee}
            distributorProfile={distributorProfile}
          />
        ) : (
          <DistributorProfileSummary distributorProfile={distributorProfile} />
        )}
      </div>
      <div className="flex-1 relative h-full rounded-lg items-center flex flex-col justify-center">
        <img
          src={imageAssetUrl("proposals/proposal-cover.webp")}
          alt="proposal-cover"
          className="h-full w-full object-contain"
        />
      </div>
    </div>
  );
}
